/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Footer_Official_SiteInputs */

const en_wc_footer_official_site = /** @type {(inputs: Wc_Footer_Official_SiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WordCraft on getartcraft.com`)
};

/**
* | output |
* | --- |
* | "WordCraft on getartcraft.com" |
*
* @param {Wc_Footer_Official_SiteInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_footer_official_site = /** @type {((inputs?: Wc_Footer_Official_SiteInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Footer_Official_SiteInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_footer_official_site(inputs)
});
export { wc_footer_official_site as "wc.footer.official_site" }